/* ============================================================
   OLFATTO · App JS — Reveal on scroll observer
   Aplica .in a [data-olfatto-reveal] cuando entra al viewport.
   Por defecto, los elementos son visibles. El observer los oculta
   primero (--pending) y luego los revela al hacer scroll.
   ============================================================ */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  function init() {
    var els = document.querySelectorAll('[data-olfatto-reveal]:not(.in):not(.olfatto-reveal--pending)');
    if (els.length === 0) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('olfatto-reveal--pending');
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Si ya está dentro del viewport al cargar, mostrar de inmediato
      if (rect.top < vh * 0.95) {
        el.classList.add('in');
      } else {
        el.classList.add('olfatto-reveal--pending');
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-escanear al navegar internamente (Shopify section render API)
  document.addEventListener('shopify:section:load', init);
})();

/* ============================================================
   OLFATTO · Cursor glow — luz cálida que sigue al cursor
   Visible en cualquier equipo con mouse (hover:hover + pointer:fine).
   No depende del ancho del viewport. No se desactiva por
   prefers-reduced-motion (solo se mueve cuando el usuario mueve el
   cursor; no hay animación automática).
   ============================================================ */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // Detectar mouse-capable device. Fail-open: si matchMedia no existe,
  // asumimos escritorio y mostramos el glow.
  var hasMatchMedia = typeof window.matchMedia === 'function';
  var isMouseDevice = true;
  if (hasMatchMedia) {
    try {
      isMouseDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    } catch (err) {
      console.warn('[olfatto-cursor-glow] matchMedia failed, assuming mouse device', err);
      isMouseDevice = true;
    }
  }
  if (!isMouseDevice) {
    console.info('[olfatto-cursor-glow] disabled: touch/coarse pointer detected');
    return;
  }

  function init() {
    try {
      if (!document.body) {
        console.warn('[olfatto-cursor-glow] init: document.body not ready, retrying');
        setTimeout(init, 50);
        return;
      }
      if (document.querySelector('.olfatto-cursor-glow')) return;

      var glow = document.createElement('div');
      glow.className = 'olfatto-cursor-glow';
      glow.setAttribute('aria-hidden', 'true');
      glow.setAttribute('data-olfatto-cursor-glow', 'mounted');
      // Append a <html> en vez de <body>: si <body> o un ancestor tiene
      // transform/filter/will-change, los hijos position:fixed quedan
      // confinados a ese stacking context. <html> evita el problema.
      document.documentElement.appendChild(glow);
      document.documentElement.setAttribute('data-olfatto-cursor-glow', 'active');

      console.info('[olfatto-cursor-glow] mounted');

      // Verificar estilos aplicados — detecta CSS cacheado/sobre-escrito.
      // Si zIndex no es '2147483646' o display es 'none', el CSS está stale
      // o algo lo está pisando.
      setTimeout(function () {
        var cs = window.getComputedStyle(glow);
        console.info('[olfatto-cursor-glow] computed', {
          zIndex: cs.zIndex,
          display: cs.display,
          position: cs.position,
          width: cs.width,
          height: cs.height,
          opacity: cs.opacity,
          background: cs.backgroundImage.substring(0, 80) + '...'
        });
      }, 0);

      var size = 600;
      // Posición inicial: CENTRO de la pantalla — así el glow es visible
      // al cargar sin esperar a un mousemove. Si todo está bien renderizado,
      // se ve apenas refrescas (mancha cálida en el medio).
      var x = window.innerWidth / 2;
      var y = window.innerHeight / 2;
      var tx = x, ty = y;
      glow.style.transform = 'translate3d(' + (tx - size / 2) + 'px, ' + (ty - size / 2) + 'px, 0)';
      glow.classList.add('is-on');
      console.info('[olfatto-cursor-glow] visible at center', x, y);

      function loop() {
        tx += (x - tx) * 0.18;
        ty += (y - ty) * 0.18;
        glow.style.transform = 'translate3d(' + (tx - size / 2) + 'px, ' + (ty - size / 2) + 'px, 0)';
        requestAnimationFrame(loop);
      }
      requestAnimationFrame(loop);

      document.addEventListener('mousemove', function (e) {
        x = e.clientX;
        y = e.clientY;
      }, { passive: true });
    } catch (err) {
      console.error('[olfatto-cursor-glow] init failed', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
